<template>
    <div class="ViewModes">
        <router-link class="ViewModes__item" :to="{name: 'object-map'}">
            <LocationIcon />
        </router-link>
        <router-link class="ViewModes__item" :to="{name: 'object-list'}">
            <BlocksIcon />
        </router-link>
        <router-link class="ViewModes__item hide-mobile" :to="{name: 'object-group-list'}">
            <LinesIcon />
        </router-link>
    </div>
</template>

<script>
import LocationIcon from '@/assets/image/icons/viewModes/location.svg?inline';
import BlocksIcon from '@/assets/image/icons/viewModes/blocks.svg?inline';
import LinesIcon from '@/assets/image/icons/viewModes/lines.svg?inline';

export default {
    name: "ViewModes",
    components: {
        LocationIcon,
        BlocksIcon,
        LinesIcon,
    },
}
</script>

<style lang="scss">
.ViewModes {
  display: flex;
  align-items: center;

  &__item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    &.router-link-exact-active {

      @include svgFill($primary);
    }

    & + & {
      margin-left: 24px;

      @include mobile {
        margin-left: 12px;
      }
    }
  }
}
</style>